const SURFACES = [
  {
    idPrefix: "featured-trip-add-button-",
    locKey: "preserve_featured_loc",
    posKey: "preserve_featured_pos"
  },
  {
    idPrefix: "ad-trip-add-button-",
    locKey: "preserve_ad_loc",
    posKey: "preserve_ad_pos",
    adKey: "preserve_ad_id"
  }
]

export function placementSlotFields(thingId) {
  const fields = {}
  SURFACES.forEach((surface) => {
    const form = document.getElementById(`${surface.idPrefix}${thingId}`)?.querySelector("form")
    if (!form?.getAttribute("action")) return

    const params = new URL(form.getAttribute("action"), window.location.origin).searchParams
    if (params.get("loc")) fields[surface.locKey] = params.get("loc")
    if (params.get("pos")) fields[surface.posKey] = params.get("pos")
    if (surface.adKey && params.get("ad_id")) fields[surface.adKey] = params.get("ad_id")
  })
  return fields
}

export function writePlacementSlots(form, thingId) {
  Object.entries(placementSlotFields(thingId)).forEach(([name, value]) => {
    let input = form.querySelector(`input[name="${name}"]`)
    if (!input) {
      input = document.createElement("input")
      input.type = "hidden"
      input.name = name
      form.appendChild(input)
    }
    input.value = value
  })
}
